import { render, staticRenderFns } from "./movieinvest.vue?vue&type=template&id=36a635f0&scoped=true&"
import script from "./movieinvest.vue?vue&type=script&lang=js&"
export * from "./movieinvest.vue?vue&type=script&lang=js&"
import style0 from "./movieinvest.vue?vue&type=style&index=0&id=36a635f0&prod&lang=less&scoped=true&"
import style1 from "./movieinvest.vue?vue&type=style&index=1&id=36a635f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a635f0",
  null
  
)

export default component.exports